<template>
  <div class="vvip-wrap">
    <div class="vvip-frame">
      <div

        class="vvip-container"
      >
        <div v-for="(vip, index) in allVipInfo" :key="index" :class="{'vvip-card': true, 'active': vip.level_name === currentVipName}">
          <div v-if="rebateInfo && rebateInfo.length > 0" class="title">
            {{ rebateInfo[index+1][0] }}
          </div>
          <div class="card-pic">
            <img :src="vip.image_big" alt="">
          </div>
          <div v-if="tableData && tableData.length > 0" class="card-content">
            <div v-if="tableData[2]" class="content upgrade">
              <div>{{ $t(tableData[2].label) }}</div>
              <div v-if="vip[`${tableData[2].key}_text_enable`]">
                {{ vip[`${tableData[2].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[2].key] }}
              </div>
            </div>

            <div v-if="tableData[3]" class="content upgrade">
              <div>{{ $t(tableData[3].label) }}</div>
              <div v-if="vip[`${tableData[3].key}_text_enable`]">
                {{ vip[`${tableData[3].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[3].key] }}
              </div>
            </div>

            <div class="dividers" />

            <div v-if="tableData[0]" class="content">
              <div>{{ $t(tableData[0].label) }}</div>
              <div v-if="vip[`${tableData[0].key}_text_enable`]">
                {{ vip[`${tableData[0].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[0].key] }}
              </div>
            </div>

            <div v-if="tableData[1]" class="content">
              <div>{{ $t(tableData[1].label) }}</div>
              <div v-if="vip[`${tableData[1].key}_text_enable`]">
                {{ vip[`${tableData[1].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[1].key] }}
              </div>
            </div>

            <div v-if="tableData[4]" class="content">
              <div>{{ $t(tableData[4].label) }}</div>
              <div v-if="vip[`${tableData[4].key}_text_enable`]">
                {{ vip[`${tableData[4].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[4].key] }}
              </div>
            </div>

            <div v-if="staticRebateData" class="content">
              <div>{{ staticRebateData[0].type }}</div>
              <div>
                {{ staticRebateData[0].vip_level_rebate_data[index].rates }}
              </div>
            </div>

            <div class="content">
              <div>{{ staticRebateData[1].type }}</div>
              <div>
                {{ staticRebateData[1].vip_level_rebate_data[index].rates }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- eslint-disable-next-line -->
      <div class="describe-frame" :class="{'active': isClamped}" v-html="vipRule">
      </div>
      <div v-if="!isClamped && vipRule.trim() !== ''" class="vip-button-wrap" @click="toggleText">
        <button class="button-style-5 vip-more">
          <span>{{ $t('Bao.more') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { page } from '@/api/common'
import { getAllVipInfo, getAllSpecialVipInfo, getRebateInfo } from '@/api/vip'
import { showNotice, getThemeImagePath } from '@/utils/tool'
import '@/assets/theme_gold/css/vip.css'

export default {
  filters: {
    commaVal: function(value, lang, tenThousand) {
      if (lang === 'vn' || lang === 'en') {
        if (isNaN(value)) return value
        if (value > 0 && value !== undefined) {
          value = String(value)
        } else {
          return value
        }

        if (value.length < 4) return value
        else if (value.length >= 4 && value.length < 7) {
          return value.slice(0, -3) + 'K'
        } else if (value.length >= 7 && value.length < 10) {
          return value.slice(0, -6) + 'M'
        } else {
          return value.slice(0, -9) + 'B'
        }
      } else {
        if (isNaN(value)) return value
        value = String(value)
        if (value.length < 5) return value

        return value.slice(0, -4) + tenThousand
      }
    }
  },
  data() {
    return {
      lang: this.$store.getters.language,
      ten_thousand: this.$t('Bao.ten_thousand'),
      thousand: this.$t('Bao.thousand'),
      million: this.$t('Bao.million'),
      allVipInfo: [
        {
          lavel_name: 'VIP1',
          image_big: '',
          note: 'VIP1'
        },
        {
          lavel_name: 'VIP2',
          image_big: '',
          note: 'VIP2'
        },
        {
          lavel_name: 'VIP3',
          image_big: '',
          note: 'VIP3'
        },
        {
          lavel_name: 'VIP4',
          image_big: '',
          note: 'VIP4'
        }
      ],
      staticRebateData: [
        {
          type: 'ライブカジノ',
          vip_level_rebate_data: [
            { rates: 'なし' }, // VIP0
            { rates: ' 0.35%' }, // VIP1
            { rates: ' 0.40%' }, // VIP2
            { rates: ' 0.45%' }, // VIP3
            { rates: ' 0.50%' }, // VIP4
            { rates: ' 0.60%' }, // VIP5
            { rates: ' 0.70%' }, // VIP6
            { rates: ' 0.90%' }, // VIP7
            { rates: ' 1.00%' }, // VIP8
            { rates: ' 1.20%' } // VIP9
          ]
        },
        {
          type: 'スロット',
          vip_level_rebate_data: [
            { rates: 'なし' }, // VIP0
            { rates: ' 0.55%' }, // VIP1
            { rates: ' 0.60%' }, // VIP2
            { rates: ' 0.70%' }, // VIP3
            { rates: ' 0.80%' }, // VIP4
            { rates: ' 1.00%' }, // VIP5
            { rates: ' 1.30%' }, // VIP6
            { rates: ' 1.50%' }, // VIP7
            { rates: ' 1.55%' }, // VIP8
            { rates: ' 1.60%' } // VIP9
          ]
        }
      ],
      activeTab: 'benefits', // default active tab
      rebateInfo: [],
      litePlayer: null,
      vipLevelShow: true,
      currentVipLevel: 1,
      selectedVip: {
        key: 0,
        upgrade_prize: 0, // 升級獎勵
        keep_bet_amount_text: 0 // 保級流水
      },
      spec_icon_show: {
        upgrade_money: true,
        monthly_prize: true,
        birthday_prize: true
      },
      slick_setting: {
        dots: false,
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        slidesToShow: 3,
        draggable: true,
        initialSlide: 0,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 968,
            settings: {
              centerPadding: '10px',
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 500,
            settings: {
              centerPadding: '25px',
              slidesToShow: 1,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 420,
            settings: {
              centerPadding: '3px',
              slidesToShow: 1,
              slidesToScroll: 3
            }
          }
        ]
      },
      vipInfo: {},
      vipRule: '',
      isClamped: false
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'vip',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
    currentVipName() {
      if (!this.$store.state.user ||
          !this.$store.state.user.vipInfo ||
          !this.litePlayer) {
        return ''
      }

      const matchNum = this.$store.state.user.vipInfo.currentVipName.match(/VIP(\d+)/)
      const matchChar = this.rebateInfo.find(array => array[0] === this.$store.state.user.vipInfo.currentVipName)

      if (matchNum) {
        const level = matchNum[1]
        let result = `VIP${level}`
        if (!level) {
          result = 'VIP9'
        }
        this.scrollToHighlighted()
        return result
      }

      if (matchChar) {
        this.scrollToHighlighted()
        return matchChar[0]
      }

      return ''
    },
    tableData() {
      return [
        {
          label: 'Bao.upgrade_prize_text',
          key: 'upgrade_prize'
        },
        {
          label: 'Bao.birthday_prize_text',
          key: 'birthday_prize'
        },
        {
          label: 'Bao.upgrade_bet_amount_text',
          key: 'upgrade_bet_amount'
        },
        {
          label: 'Bao.upgrade_deposit',
          key: 'upgrade_deposit'
        },
        {
          label: 'Bao.keep_bet_amount',
          key: 'keep_bet_amount'
        }
      ]
    },
    alignedRebateInfo() {
      return this.rebateInfo.slice(1)
    }
  },
  created() {
    getAllVipInfo()
      .then((response) => {
        this.allVipInfo = response.data.data

        this.setCurrentVipLevel()
        this.slick_setting.initialSlide = this.currentVipLevel - 1
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
    getAllSpecialVipInfo()
      .then((response) => {
        this.litePlayer = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })

    const timestamp = Date.now()
    page({ type: 'vip_rule', timestamp: timestamp }).then(response => {
      this.vipRule = response.data.data.content
    })
    this.scrollToHighlighted()
  },
  mounted() {
    getRebateInfo({ reverse_data: false })
      .then((response) => {
        this.rebateInfo = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
  },
  methods: {
    scrollToHighlighted() {
      this.$nextTick(() => {
        setTimeout(() => {
          const highlightedItem = this.$el.querySelector('.vvip-card.active')
          if (highlightedItem) {
            highlightedItem.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 700)
      })
    },
    setCurrentVipLevel() {
      if (!this.$store.state.user ||
          !this.$store.state.user.vipInfo) {
        return
      }

      for (const i in this.allVipInfo) {
        if (this.$store.state.user.vipInfo.currentVipName === this.allVipInfo[i].level_name) {
          this.currentVipLevel = this.allVipInfo[i].level

          this.selectedVip = {
            key: i,
            upgrade_prize: this.allVipInfo[i].upgrade_prize,
            keep_bet_amount_text: this.allVipInfo[i].keep_bet_amount_text
          }
          this.setCurrentVipSpecIcon(this.allVipInfo[i].spec_icon_show)
        }
      }
    },
    areAllRatesZero(vipLevelRebateData) {
      return vipLevelRebateData.every(vipData => {
        const rate = vipData.rates[0]
        return rate === '' || parseFloat(rate) === 0
      })
    },
    getI18nKey(type) {
      if (type === 'slot') {
        return this.$t('Bao.slot_game')
      } else if (type === 'live') {
        return this.$t('Bao.live_game')
      } else if (type === 'chess') {
        return this.$t('Bao.poker_game')
      } else if (type === 'skill_game') {
        return this.$t('Bao.skill_game')
      } else if (type === 'roulette') {
        return this.$t('Bao.roulette_game')
      } else if (type === 'pachinko') {
        return this.$t('Bao.pachinko_game')
      }

      return type
    },
    changeCarousel(index) {
      this.selectedVip = {
        key: index,
        upgrade_prize: this.allVipInfo[index].upgrade_prize,
        keep_bet_amount_text: this.allVipInfo[index].keep_bet_amount_text
      }

      this.setCurrentVipSpecIcon(this.allVipInfo[index].spec_icon_show)
    },
    setCurrentVipSpecIcon(select_spec_icon_show) {
      if (select_spec_icon_show) {
        this.spec_icon_show.upgrade_money = (select_spec_icon_show.indexOf('upgrade_money') > -1)
        this.spec_icon_show.monthly_prize = (select_spec_icon_show.indexOf('monthly_prize') > -1)
        this.spec_icon_show.birthday_prize = (select_spec_icon_show.indexOf('birthday_prize') > -1)
      } else {
        this.spec_icon_show = {
          upgrade_money: false,
          monthly_prize: false,
          birthday_prize: false
        }
      }
    },
    toggleText() {
      this.isClamped = !this.isClamped
    },
    getThemeImagePath,
    getAlignedRebateInfo(index) {
      return this.rebateInfo[index + 1]
    }
  }
}
</script>

<style>
.slick-prev:before, .slick-next:before {
  content: ''
}
.bg-transparent {
  background-color: transparent;
  transform-origin: center !important;
}
.slider-products .slick-slide {
  opacity: 0;
  width: 280px;
}
.slider-products .slick-active{
  opacity: 1;
}
.vip .vip-lv .vip-lv-list .vip_privilege_card .slick-slide.slick-active button {
  overflow: hidden;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
  border-color: transparent;
  -webkit-filter: blur(2px);
          filter: blur(2px);
  -webkit-transform-origin: center left;
          transform-origin: center left;
  z-index: -1;
  pointer-events: none;
  transform: scale(0.35);
}
.vip .vip-lv .vip-lv-list .vip_privilege_card .slick-slide.slick-center.slick-current {
  /* -webkit-filter: drop-shadow(0 3px 6px rgba(235, 211, 133, 0.3)); */
  position: relative;
  z-index: 1;
  pointer-events: visible;
  filter: drop-shadow(2px 25px 25px rgba(10,10,10, .75));
}
.vip .vip-lv .vip-lv-list .vip_privilege_card .slick-slide.slick-current.slick-center button {
  -webkit-filter: blur(0);
          filter: blur(0);
  -webkit-transform-origin: center center;
          transform-origin: center center;
  transform: scale(.9);
}
.highlight-frame:before {
    content: "";
    position: absolute;
    top: -5px;
    width: 8%;
    height: 100%;
    border: 5px solid #FFDD00;
    display: block;
}
.vip-lv-detail h2{
  font-size: 100%;
}
@media (max-width: 440px) {
.highlight-frame:before {
    content: "";
    position: absolute;
    padding-right: 5px;
    top: 1px;
    width: 22%;
    height: 94%;
    border: 4.8px solid #FFDD00;
}
}
</style>
